import { Group } from "@/types/group";

export const isPublicGroup = (g?: Pick<Group, "visibility"> | null) =>
  g?.visibility === "public";
